import {Component} from '@angular/core';
import {NavController, ToastController} from 'ionic-angular';
import {AngularFireAuth} from 'angularfire2/auth';

import {Data} from '../../providers/providers';
import {LocationListPage} from "../location-list/location-list";

@Component({
  selector: 'password-reset',
  templateUrl: 'password-reset.html'
})

export class PasswordResetPage {

  email: string;

  constructor(public navCtrl: NavController,
              private firebaseAuth: AngularFireAuth,
              public data: Data,
              public toastCtrl: ToastController) {
  }

  doReset() {
    this.firebaseAuth
      .auth
      .sendPasswordResetEmail(this.email)
      .then(() => {
        alert('A password-reset link has been sent to your email.')
      },
        (error) => {
          alert(error)
        })
  }
}



// WEBPACK FOOTER //
// ./src/pages/password-reset/password-reset.ts